(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('deliveryPlanning', {
        templateUrl: 'views/components/views/deliveryPlanning/deliveryPlanning.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'modalService', 'translateService', 'deliveryPlanningService', 'logisticService', 'rememberService', function (stateService, utilityService, modalService, translateService, deliveryPlanningService, logisticService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            let variableNames = {
                businessco_no: '',
                stockplace_id: '',
                selecttype_id: '',
                stocklocation_keyno: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                selectTypeButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('selecttype_id') }
                ],
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
                ],
                bgNeedType: {
                    selected: 'OH',
                    buttons: [
                        { id: 'OH', label: 'bg_need_type_oh', color: 'primary', onClick: () => vm.model.bgNeedType.selected = 'OH' },
                        { id: 'RO', label: 'bg_need_type_ro', color: 'primary', onClick: () => vm.model.bgNeedType.selected = 'RO' },
                        { id: 'RS', label: 'bg_need_type_rs', color: 'primary', onClick: () => vm.model.bgNeedType.selected = 'RS' }
                    ]
                },
                bgDeliveryPlanningFunction: {
                    selected: 'SELECT',
                    buttons: [
                        { id: 'SELECT', label: 'bg_deliveryplanning_function_select', color: 'primary', onClick: () => vm.model.bgDeliveryPlanningFunction.selected = 'SELECT' },
                        { id: 'SHOW', label: 'bg_deliveryplanning_function_show', color: 'primary', onClick: () => vm.model.bgDeliveryPlanningFunction.selected = 'SHOW' }
                    ]
                },
                setting: {},
                selectListCompanies: [],
                selectListStockPlaces: [],
                selectListDeliveryPlanningTypes: [],
                selectListStockLocations: [],
                selectListTrolleys: [],
                selectListConsignmentShipments: [],
                itemsListDeliveryPlannings: [],
                lockedCreate: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await deliveryPlanningService.getSetting())[0];

                return Promise.all([
                    loadStockPlaces(),
                    loadStockLocations(),
                    loadTrolleys(),
                    loadConsignmentShipments()
                ]).then(() => {
                    loadDeliveryPlannings();
                    Promise.resolve();
                });
            }

            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }

            async function loadDeliveryPlanningTypes() {
                vm.model.selectListDeliveryPlanningTypes = await deliveryPlanningService.listDeliveryPlanningTypes();
            }
            
            async function loadStockPlaces() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
                
                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
            };
            
            async function loadStockLocations() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                
                return vm.model.selectListStockLocations = await logisticService.listStockLocations({ stockplace_id: vm.model.setting.stockplace_id });
            }
            
            async function loadTrolleys() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                
                return vm.model.selectListTrolleys = await logisticService.listTrolleys({ stockplace_id: vm.model.setting.stockplace_id });
            }
            
            async function loadConsignmentShipments() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                
                return vm.model.selectListConsignmentShipments = await deliveryPlanningService.listConsignmentShipments({ stockplace_id: vm.model.setting.stockplace_id });
            }

            async function loadDeliveryPlannings() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stocklocation_keyno, true) !== true) return;

                vm.model.itemsListDeliveryPlannings = [];

                return vm.model.itemsListDeliveryPlannings = await deliveryPlanningService.listDeliveryPlannings(vm.model.setting);
            }

            function retrieveStockPlaceId() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                
                return deliveryPlanningService.changeStockPlaceId({ stockplace_id: vm.model.setting.stockplace_id }).then(function (response) {
                    vm.model.setting.floating_location = response[0].floating_location;
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                    	case 'businessco_no':
                            variableNames[key] = stateService.getCurrentName() + '.' + key;
                            break;
                        case 'stockplace_id':
                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + 'businessco_no' + '=' + vm.model.setting.businessco_no;
                            break;
                        case 'selecttype_id':
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                        case 'stocklocation_keyno':
                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + 'stockplace_id' + '=' + vm.model.setting.stockplace_id;
                            break;
                    	default:
                    		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                    		break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'businessco_no':
                    case 'stockplace_id':
                    case 'selecttype_id':
                    case 'stocklocation_keyno':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RETRIEVE LAST VALUE MULTI PROCEDURE FUNCTION CALLS

            function retrieveLastStatusFunc(id) {
                let variableName = null;

                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        variableName = 'deliveryplanning.stockplace_id.businessco_no=' + vm.model.setting.businessco_no;

                        return rememberService.getLastStatus(variableName).then((lastState) => {
                            if (lastState[0].variablevalue === '') {
                                vm.model.setting.stockplace_id = '0';

                                return Promise.all([
                                    loadStockLocations(),
                                    loadTrolleys(),
                                    loadConsignmentShipments()
                                ]).then(() => {
                                    loadDeliveryPlannings();
                                    Promise.resolve();
                                });
                            } else {
                                vm.model.setting.stockplace_id = lastState[0].variablevalue;

                                return Promise.all([
                                    loadStockLocations(),
                                    loadTrolleys(),
                                    loadConsignmentShipments()
                                ]).then(() => {
                                    loadDeliveryPlannings();
                                    Promise.resolve();
                                });
                            }
                        });
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

                        variableName = 'deliveryplanning.stocklocation_keyno.stockplace_id=' + vm.model.setting.stockplace_id;

                        return rememberService.getLastStatus(variableName).then((lastState) => {
                            if (lastState[0].variablevalue === '') {
                                vm.model.setting.stocklocation_keyno = '0';
                            } else {
                                vm.model.setting.stocklocation_keyno = lastState[0].variablevalue;
                            }
                        });
                        break;
                    default:
                        break;
                }
            }

            // #endregion RETRIEVE LAST VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region CLEAR BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'selecttype_id':
                        vm.model.setting.selecttype_id = 'ALL';

                        if (vm.model.setting.selecttype_id === 'ALL') {
                            return Promise.all([
                                rememberFunc('selecttype_id')
                            ]).then(() => {
                                loadDeliveryPlannings();
                                Promise.resolve();
                            });
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion CLEAR BUTTON FUNCTION

            // #region BUTTON CREATE PROCEDURE FUNCTION CALL

            vm.createChanges = function () {
                vm.model.lockedCreate = true;
                
                let mergeObj = {};
                let setting = {};
                let itemsListDeliveryPlannings = [];

                setting = vm.model.setting;
                mergeObj = setting;
                itemsListDeliveryPlannings = vm.model.itemsListDeliveryPlannings;

                mergeObj.records = [];
                mergeObj.records = itemsListDeliveryPlannings;

                deliveryPlanningService.createObj(mergeObj).then((response) => {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedCreate = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedCreate = false;
                        loadDeliveryPlannings();
                    }
                });
            };

            // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgNeedType = function (value) {
                vm.model.bgNeedType.selected = value;
                vm.model.setting.bg_need_type = vm.model.bgNeedType.selected;

                if (vm.model.setting.bg_need_type > '') loadDeliveryPlannings();
            };

            vm.selectBgDeliveryPlanningFunction = function (value) {
                vm.model.bgDeliveryPlanningFunction.selected = value;
            };

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        return Promise.all([
                            rememberFunc('businessco_no'),
                            retrieveLastStatusFunc('businessco_no')
                        ]).then(() => {
                            loadStockPlaces();
                            Promise.resolve();
                        });
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                        vm.model.setting.stockplace_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

                        return Promise.all([
                            rememberFunc('stockplace_id'),
                            retrieveLastStatusFunc('stockplace_id'),
                            loadStockLocations(),
                            loadTrolleys(),
                            retrieveStockPlaceId()
                        ]).then(() => {
                            loadConsignmentShipments();
                            loadDeliveryPlannings();
                            Promise.resolve();
                        });
                        break;
                    case 'stocklocation_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stocklocation_keyno) !== true) return;

                        vm.model.setting.stocklocation_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stocklocation_keyno) !== true) return;

                        rememberFunc('stocklocation_keyno');
                        break;
                    case 'selecttype_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.selecttype_id) !== true) return;

                        vm.model.setting.selecttype_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.selecttype_id) !== true) return;

                        return Promise.all([
                            rememberFunc('selecttype_id')
                        ]).then(() => {
                            loadDeliveryPlannings();
                            Promise.resolve();
                        });
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                loadCompanies();
                loadDeliveryPlanningTypes();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
